import React from 'react';
import { Button, useTheme, useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import arrowLeft from "../../../../../assets/icons/ArrowLeft.svg";

const BackButton: React.FC = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const arrowLeftUrl = arrowLeft; // use the imported string directly

  const handleClick = () => {
    navigate(-1);
  };

  return (
    <Button
      onClick={handleClick}
      className="flex flex-row items-center gap-1 hover:opacity-80 transition-opacity"
      sx={{
        alignSelf: 'flex-start',
        marginLeft: 0,
        minWidth: isMobile ? '50px' : '65px',
        height: '6ch',
        textTransform: 'none',
        padding: 0,
        color: '#5547dd',
        fontFamily: 'Inter Tight',
        fontWeight: 700,
        fontSize: isMobile ? '14px' : '16px',
        lineHeight: '24px',
      }}
    >
      <img 
        src={arrowLeftUrl} 
        alt="Back arrow"
        className="w-6 h-6"
      />
      <span>Back</span>
    </Button>
  );
};

export default BackButton;
